module.exports = __webpack_public_path__ + "img/img6.60537036.jpg";